import { useLazyQuery } from "@apollo/client";
import { Badge, Button, createStyles, IconButton, makeStyles, Theme, withStyles } from "@material-ui/core";
import clsx from "clsx";
import { PopUp } from "components/Menu/styles";
import useText from "constants/text";
import { useNotification } from "contexts/NotificationContext";
import { isAfter } from "date-fns";
import { GET_NOTIFICATIONS } from "domains/Notification/graphql/queries";
import { EPlatform } from "generated/graphql";
import { useCurrentUser } from "hooks";
import { RingIcon } from "icons";
import React, { useMemo } from "react";
import { isSuccess } from "utils/https";
import { NotificationPopUpItem } from "./NotificationPopUpItem";

export const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}))(Badge);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: "12px",
      marginBottom: "auto",
      position: "relative",
      right: "15px",
    },
    none: {
      display: "none",
    },
    container: {
      display: "flex",
      height:"781px",
      overflowX:"hidden"
    },
    mainPadding: {
      padding: 20,
      paddingRight: 0,
      height: "100%",
      width: "100%",
    },
    mainTitle: {
      color: theme.palette.primary.main,
      fontWeight: "bold",
    },
    notifications: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      justifyContent: "space-evenly",
      overflowY: "scroll",
      paddingTop: 10,
    },
    btn: {
      marginLeft: "auto",
      marginRight: "auto",
      borderRadius: 25,
      fontWeight: 600,
      fontSize: 14,
      width: 120,
      border: "1px solid #f1f1ea",
      marginTop: 20,
    },
    dismiss: {
      display: "none",
    },
  })
);

export interface NotificationProps {
  onClick: any;
  popit?: boolean;
  onClickItem?: any;
}

export function NotificationPopUp({ popit = true, onClick, onClickItem }: NotificationProps) {
  const styles = useStyles();
  const { text } = useText();
  const [notifications, setNotifications] = React.useState([]);
  const { user, code } = useCurrentUser();
  const { badge } = useNotification();
  const filter = { page: 1, limit: 10, search: "" };
  const [getNotifications, { data }] = useLazyQuery(GET_NOTIFICATIONS, {
    fetchPolicy: "network-only",
  });

  React.useEffect(() => {
    if (code === 200)
      getNotifications({ variables: { viewerID: user?.company_user_clientId, filter, platform: EPlatform.Client } });
  }, [badge]);

  React.useEffect(() => {
    if (isSuccess(data)) {
      setNotifications(data?.results?.data)      
    }
  }, [data]);

  const handleClick = () => {
    onClick();
    onClickItem();
  };

    const sortNotifications=useMemo(()=>notifications?.
    sort( (a,b) => isAfter(b?.createdAt,a?.createdAt)? 1 : 0),[notifications])
 
  return (
    <>
      <div className={styles.root}>
        <IconButton aria-label="cart" onClick={onClick}>
          <StyledBadge badgeContent={badge > 99 ? `+99` : badge} color="primary">
            <RingIcon height={20} width={20} />
          </StyledBadge>
        </IconButton>
        <PopUp className={clsx(popit ? "popup" : "dismiss")}>
          <div className={styles.container}>
            <div className={styles.mainPadding}>
              <div className={styles.mainTitle}>Notifications</div>
              <div className={styles.notifications}>
                {sortNotifications.map((notification, key) => (
                  <NotificationPopUpItem notification={notification} key={key} onClickItem={handleClick} />
                ))}
                <Button variant="text" onClick={handleClick} className={styles.btn} color="primary">
                  {text.all.view_more}
                </Button>
              </div>
            </div>
          </div>
        </PopUp>
      </div>
    </>
  );
}
